import React, { useState, useEffect } from "react";
import { styled } from "../../../../stitches.config";

import WithLazyLoad from "../../../HOCs/WithLazyLoad"
import AnimateHeightWrapper, { AnimateWrapperButton } from "../../Parts/Brid/common/components/AnimateHeightWrapper";
import AnimateFixedHeightWrapper from "../../Parts/Brid/common/components/AnimateFixedHeightWrapper";

import shareIcon from "../../../../redesign/assets/icons/socialbutton-share.svg"
import NoSSR from "../../../../helpers/NoSSR";

const FacebookProvider = React.lazy(() => import(/* webpackChunkName: "react-facebook" */"react-facebook").then(m => ({ default: m.FacebookProvider })));
const EmbeddedPost = React.lazy(() => import(/* webpackChunkName: "react-facebook" */"react-facebook").then(m => ({ default: m.EmbeddedPost })));
const EmbeddedVideo = React.lazy(() => import(/* webpackChunkName: "react-facebook" */"react-facebook").then(m => ({ default: m.EmbeddedVideo })));

const FacebookPost = (props) => {
  const [visibility, setVisibility] = useState(false)
  const appId = (window?.APP_SETTINGS?.facebook_app_id);

  const [node, setNode] = useState(null);
  const ref = (node) => {
    if (node !== null)
      setNode(node);
  };

  useEffect(() => {
    if (node == null)
      return;

    const resize = new ResizeObserver(() => {
      const height = node.getBoundingClientRect().height;
      if (height > 361) {
        setVisibility(true);
      } else {
        setVisibility(false);
      }
    });
    resize.observe(node);

    return () => resize.disconnect();
  }, [node]);

  return (
    <NoSSR fallback={null}>
      <FacebookProvider language="pl_PL" appId={appId} lazy={true}>
        {/* ukrycie react-lazy, konflikt z react-facebook #10395 */}

        {/* <WithLazyLoad options={{
        height: 480,
        once: true,
        offset: 600
      }}>
      <AnimateFixedHeightWrapper>
        <CenteredEmbed ref={ref}>
          {props.type == "video" ? <EmbeddedVideo href={props.href} /> : <EmbeddedPost href={props.href} />}
        </CenteredEmbed>
      </AnimateFixedHeightWrapper>
      </WithLazyLoad> */}
        <ExtraWrapper>
          <AnimateFixedHeightWrapper>
            <CenteredEmbed ref={ref}>
              {props.type == "video" ? <EmbeddedVideo href={props.href} /> : <EmbeddedPost href={props.href} />}
            </CenteredEmbed>
          </AnimateFixedHeightWrapper>
        </ExtraWrapper>
      </FacebookProvider>
    </NoSSR>
  );
}

export default FacebookPost;

const CenteredEmbed = styled("div", {
  textAlign: "center",
  minHeight: "200px",
  position: "relative",
  "&::before": {
    minHeight: "350px",
    height: "100%",
    content: "",
    background: `transparent url("${shareIcon}") no-repeat center center`,
    backgroundSize: "60px",
    opacity: 0.4,
    top: "0",
    left: "0",
    right: "0",
    position: "absolute",
    zIndex: 0
  },
  ".fb-post > span": {
    maxWidth: "100%"
  },
  ".fb-post iframe": {
    border: "0",
    display: "block",
    position: "relative",
    margin: "0 auto",
    maxWidth: "100%",
    background: "#fff"
  }
});

const ExtraWrapper = styled("div", {
  margin: "0px auto",
  width: "auto",
  maxWidth: "840px",
  paddingBottom: "0px",
  height: "auto",
});
